/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */
import React, { memo, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, TextInput, Dropdown, DatePicker, NumberInput, Attachment, MoneyInput } from 'diginet-core-ui/components';
import Config from '../../../../config/index';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import * as W06F0009Actions from '../../../../redux/W0X/W06F0009/W06F0009_actions';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import CDN from "../../../CDN/index";
import W91F0001 from '../../W09/W91F0001/W91F0001';
import MForm from "../../../common/form-material/form";

const TabGeneral = memo(forwardRef((props, ref) => {
    const { classes, formData, decimalQuantity, mode, onSetIsUpdate, ContractID } = props;
    const dispatch = useDispatch();
    const initData = {
        //general
        VoucherTypeID: '', SubContractNo: '', LastKey: '', IsApprove: '0', CurrencyID: '', ExchangeRate: '', SubContractDate: new Date(),
        EmployeeID: Config.profile.UserID, StartDate: new Date(), FinishDate: new Date(),
        SubContractType: 0,
        //customer
        SupplierID: '', SupplierName: '', ObjectAddressU: '', VATNo: '', BankAccountNo: '', TelNo: '', FaxNo: '', Notes: '',
        IsGuarantee: 0, GObjectID: '', SupplierTypeID: '',
        //delivery
        DeliveryMethodID: '', SendDate: new Date(), PortNameF: '', PortNameT: '', PaymentMethodID: '', BankID: '',
        RefExchangeRate: '', RefTotal: '', RefCTotal: '',
    }

    const [attachment, setAttachment] = useState([]);

    const [arrSupplement, setArrSupplement] = useState([]);

    const [dataGeneral, setDataGeneral] = useState(initData);

    const refAttachment = useRef(null);
    const attachments = useRef([]);
    const deletedFile = useRef([]);
    const attachmentsTemp = useRef([]);

    const [openModalCustomer, setOpenModalCustomer] = useState(false);

    const setState = (obj) => {
        setDataGeneral({ ...dataGeneral, ...obj });
    }

    const getData = (key, defaultValue = "") => {
        return _.get(formData, key, defaultValue);
    }

    const [cbTypeAppendix, setCbTypeAppendix] = useState([]);

    const [filterCbEmployees, setFilterCbEmployees] = useState({ limit: 20, skip: 0, StrSearch: '' });
    const [cbEmployees, setCbEmployees] = useState({ total: 0, rows: [] });

    const [filterCbCustomer, setFilterCbCustomer] = useState({ limit: 20, skip: 0, StrSearch: '', ObjectTypeID: 'KH' });
    // const [cbCustomer, setCbCustomer] = useState({ total: 0, rows: [] });

    const [filterCbConsignment, setFilterCbConsignment] = useState({ limit: 20, skip: 0, StrSearch: '', ObjectTypeID: 'KH' });
    const [cbConsignment, setCbConsignment] = useState({ total: 0, rows: [] });

    const [cbPaymentMenthod, setCbPaymentMenthod] = useState([]);
    const [cbSubContractType, setCbSubContractType] = useState([]);

    const isReadOnlySubConTractNo = useRef(true);
    const Auto = useRef(0);

    const oldDataMaster = useRef(null);

    const diff = useRef({});

    const [errors, setErrors] = useState({});

    useImperativeHandle(ref, () => ({
        onSave, onCreateSaveHistory
    }))

    const setData = async () => {
        const setData = {
            VoucherTypeID: getData('VoucherTypeID'), SubContractNo: getData('SubContractNo', ''), IsApprove: getData('IsApprove', '0'),
            CurrencyID: getData('CurrencyID'), ExchangeRate: getData('ExchangeRate'), SubContractDate: getData('SubContractDate', new Date()),
            EmployeeID: getData('EmployeeID', Config.profile.UserID), StartDate: getData('StartDate', new Date()), FinishDate: getData('FinishDate', new Date()),
            SubContractType: getData('SubContractType', 0), PaymentMethodID: getData('PaymentMethodID'),
            //customer
            SupplierID: getData('SupplierID'), SupplierName: getData('SupplierName'), ObjectAddressU: getData('ObjectAddressU'), VATNo: getData('VATNo'),
            BankAccountNo: getData('BankAccountNo'), TelNo: getData('TelNo'), FaxNo: getData('FaxNo'), Notes: getData('Notes'),
            IsGuarantee: getData('IsGuarantee', 0), GObjectID: getData('GObjectID'), SupplierTypeID: getData('SupplierTypeID')
        };
        setAttachment([...props.attachments]);
        arrSupplement.forEach(rs => {
            if (!(typeof formData[rs.FieldName] === "undefined")) {
                if (rs.DataType === 'datetime') {
                    setData[rs.FieldName] = formData[rs.FieldName] ? moment(formData[rs.FieldName]).format('YYYY-MM-DD') : null;
                } else {
                    setData[rs.FieldName] = formData[rs.FieldName];
                }
            }
        });
        oldDataMaster.current = { ...setData };
        setState(setData);
    }

    useEffect(() => {
        if (formData) {
            setData();
        }
        /* eslint-disable */
    }, [formData, arrSupplement])

    useEffect(() => {
        getCbEmployees();
        /* eslint-disable */
    }, [filterCbEmployees])

    // useEffect(() => {
    //     getCbCustomer();
    //     /* eslint-disable */
    // }, [filterCbCustomer])

    useEffect(() => {
        getCbConsignment();
        /* eslint-disable */
    }, [filterCbConsignment])
    const isgetMasterSupplement = useRef(false);

    useEffect(() => {
        if (dataGeneral.VoucherTypeID && mode === 'add') {
            const itemTypeAppendix = cbTypeAppendix.find(rs => rs.VoucherTypeID === dataGeneral.VoucherTypeID);
            if (itemTypeAppendix) {
                Auto.current = itemTypeAppendix.Auto;
                if (itemTypeAppendix.Auto) {
                    _subContractNo(itemTypeAppendix, 0);
                    isReadOnlySubConTractNo.current = true;
                } else {
                    setState({ SubContractNo: '', LastKey: '' });
                    isReadOnlySubConTractNo.current = false;
                }
            }
        }
        /* eslint-disable */
    }, [dataGeneral.VoucherTypeID, cbTypeAppendix, isgetMasterSupplement.current])

    useEffect(() => {
        getCboTypeAppendix();
        getCboPaymentMenthod();
        getMasterSupplement();
        getCbSubContractType();
        /* eslint-disable */
    }, [])

    const getCboTypeAppendix = () => {
        dispatch(W06F0009Actions.getCboTypeAppendix(null, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setCbTypeAppendix(data);
        }));
    }

    const _subContractNo = (e, isSave, cb) => {
        const params = e;
        params.Mode = isSave;
        dispatch(W06F0009Actions.subContractNo(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setState(data);
            checkDiff('SubContractNo', data.SubContractNo);
            oldDataMaster.current.SubContractNo = data.SubContractNo;
        }));
    }

    const getCbEmployees = () => {
        dispatch(W06F0009Actions.getCbEmployees(filterCbEmployees, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            const rows = cbEmployees.rows.length <= 0 ? data.rows : cbEmployees.rows.concat(data.rows);
            setCbEmployees({ total: data.total, rows });
        }));
    }

    const getCbSubContractType = () => {
        const params = {
            ContractID: ContractID,
            Language: Config.language || 84
        }
        dispatch(W06F0009Actions.getCbSubContractType(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setCbSubContractType(data);
        }));
    }

    const getCbConsignment = () => {
        dispatch(W06F0009Actions.getCbCustomer(filterCbConsignment, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            const rows = cbConsignment.rows.length <= 0 ? data.rows : cbConsignment.rows.concat(data.rows);
            setCbConsignment({ total: data.total, rows });
        }));
    }

    const getCboPaymentMenthod = () => {
        dispatch(W06F0009Actions.getCboPaymentMenthod(null, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setCbPaymentMenthod(data);
        }));
    }

    const getMasterSupplement = () => {
        dispatch(W06F0009Actions.getMasterSupplement({ TableName: 'D49T2000-PO', Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            if (data?.length > 0) {
                const dataFilter = data.filter(rs => Number(rs.DefaultUse) === 1);
                setArrSupplement(dataFilter);
                isgetMasterSupplement.current = true;
            }

        }));
    }

    const checkDiff = (key, vl) => {
        if (moment(vl, moment.ISO_8601, true).isValid() || moment(vl, 'YYYY/MM/DD', true).isValid()) {
            diff.current[key] = moment(formData[key]).format('YYYY/MM/DD') !== moment(vl).format('YYYY/MM/DD');
        } else {
            diff.current[key] = formData[key] !== vl;
        }
    }

    const handleChange = (name, e, other) => {
        onSetIsUpdate();
        switch (name) {
            case 'VoucherTypeID':
            case 'IsApprove':
            case 'SubContractDate':
            case 'EmployeeID':
            case 'StartDate':
            case 'FinishDate':
            case 'DeliveryMethodID':
            case 'SendDate':
            case 'PortNameF':
            case 'PortNameT':
            case 'PaymentMethodID':
            case 'BankID':
            case 'GObjectID':
            case 'SubContractType':
                setState({ [name]: e.value });
                checkDiff(name, e.value);
                break;
            case 'Notes':
            case 'SubContractNo':
                setState({ [name]: e.target.value });
                checkDiff(name, e.target.value);
                break;
            case 'SupplierID':
                setState({
                    [name]: e.ObjectID, ObjectAddressU: e.ObjectAddressU, VATNo: e.VATNo,
                    BankAccountNo: e.BankAccountNo, TelNo: e.TelNo, FaxNo: e.FaxNo,
                    SupplierName: e.ObjectNameU
                });
                checkDiff(name, e.ObjectID);
                checkDiff('ObjectAddressU', e.ObjectAddressU);
                checkDiff('VATNo', e.VATNo);
                checkDiff('BankAccountNo', e.BankAccountNo);
                checkDiff('TelNo', e.TelNo);
                checkDiff('FaxNo', e.FaxNo);
                break;
            case 'RefExchangeRate':
                const _RefTotal = e.target.value * formData.OTotal;
                setState({ [name]: e.target.value, RefTotal: _RefTotal, RefCTotal: _RefTotal * formData.ExchangeRate });
                checkDiff(name, e.target.value);
                break;
            case 'arrSupplement':
                setState({ [other]: e });
                checkDiff(other, e);
                break;
            default:
                break;
        }
    }

    const onChangeAttachments = e => {
        attachments.current = e.allNewAttached ? e.allNewAttached : [];
        if (e.removedAttached && e.removedAttached.length > 0) {
            deletedFile.current = [...e.removedAttached];
            const _arrRemove = deletedFile.current.map(d => d.AttachmentID);
            const att = attachment.filter(att => {
                return _arrRemove.indexOf(att.AttachmentID) < 0;
            });
            setAttachment(att);
        }
        onSetIsUpdate();
    };

    const _uploadFile = (files, isAsync, cb) => {
        if (isAsync) {
            return CDN.uploadFileSync(files);
        } else {
            return CDN.uploadFile(files, null, cb);
        }
    };

    const _getAttachments = file => {
        const dataFile = _.get(file, "data.paths", []);
        const listAttachments = Config.helpers.getFileInfomations(dataFile);
        let arrAttachment = [];
        listAttachments.forEach(att => {
            arrAttachment.push({
                URL: att.url ? att.url : "",
                FileName: att.fileName ? att.fileName : "",
                FileSize: att.fileSize ? att.fileSize : "",
                FileExt: att.fileName ? att.fileName.split(".").pop() : "",
            });
        });
        if (attachment.length > 0) {
            arrAttachment = attachment.concat(arrAttachment);
        }
        return arrAttachment;
    };

    const onSave = async () => {
        const resultValidate = checkValidateMaster(["SubContractNo"]);
        const validateForm = MForm.formValidation(resultValidate);
        if (Object.keys(validateForm).length > 0) {
            setStateErrorText(validateForm);
            return false;
        }

        const params = { ...dataGeneral };
        params.SubContractDate = params.SubContractDate && moment(params.SubContractDate).format('YYYY-MM-DD');
        params.StartDate = params.StartDate && moment(params.StartDate).format('YYYY-MM-DD');
        params.FinishDate = params.FinishDate && moment(params.FinishDate).format('YYYY-MM-DD');
        params.Auto = Auto.current;
        const dataResUploadFile = await _uploadFile(attachments.current, true);
        const arrAttachments = _getAttachments(dataResUploadFile);
        attachmentsTemp.current = arrAttachments;
        const attachment = JSON.stringify(arrAttachments);
        return { ...params, attachment };
    }

    const getCodeLangMaster = (keyName) => {
        const master = {
            //general
            VoucherTypeID: 'Loai_phu_luc', SubContractNo: 'So_phu_luc', IsApprove: 'Trang_thai',
            CurrencyID: 'Loai_tien', ExchangeRate: 'Ty_gia', SubContractDate: 'Ngay_lap',
            EmployeeID: 'Nguoi_lapU', StartDate: 'Ngay_bat_dau', FinishDate: 'Ngay_ket_thuc',
            SubContractType: 'Loai_dieu_chinh', PaymentMethodID: 'Phuong_thuc_thanh_toan',
            //customer
            SupplierID: 'Nha_cung_cap', ObjectAddressU: 'Dia_chi', VATNo: 'Ma_so_thue', BankAccountNo: 'Tai_khoan',
            TelNo: 'So_dien_thoai', FaxNo: 'So_fax', Notes: 'Ghi_chu', GObjectID: 'Don_vi_uy_thac',
        };
        arrSupplement.forEach(rs => {
            master[rs.FieldName] = rs.Caption;
        });

        return keyName ? master[keyName] : master;
    }

    const getOptions = (newValue, SubContractID) => {
        let options = [];
        if (mode === 'add') {
            options.push({
                codeID: SubContractID,
                formID: "W06F0009",
                action: 0,
                newValue: newValue,
                description84: Config.lang('Phu_luc_hop_dong', 'vi'),
                description01: Config.lang('Phu_luc_hop_dong', 'en'),
                hasURL: false
            });
        } else {
            const masterKey = Object.keys(getCodeLangMaster());
            masterKey.forEach((value) => {
                if (dataGeneral[value] !== oldDataMaster.current[value]) {
                    const description = getCodeLangMaster(value);
                    let el = {};
                    el.codeID = SubContractID;
                    el.formID = 'W06F0009';
                    el.linkedTrans = '';
                    el.action = 1;
                    el.description84 = Config.lang(description, 'vi');
                    el.description01 = Config.lang(description, 'en');
                    el.oldValue = oldDataMaster.current[value]
                    el.newValue = dataGeneral[value]
                    el.hasURL = false;
                    options.push(el);
                }
            });
        }
        return options;
    }

    const onCreateAttachmentHistory = (SubContractID) => {
        const options = [];
        if (mode === 'add') {
            attachmentsTemp.current.forEach(rs => {
                options.push({
                    codeID: SubContractID,
                    formID: "W06F0009",
                    action: 2,
                    newValue: rs.FileName,
                    description84: Config.lang('Dinh_kem', 'vi'),
                    description01: Config.lang('Dinh_kem', 'en'),
                    hasURL: false
                });
            })
        } else {
            if (props.attachments && props.attachments.length > 0) {
                props.attachments.forEach((item) => {
                    if (!attachmentsTemp.current.find(rs => rs.URL === item.URL)) {
                        options.push({
                            codeID: SubContractID,
                            formID: "W06F0009",
                            action: 3,
                            oldValue: item.FileName,
                            description84: Config.lang('Dinh_kem', 'vi'),
                            description01: Config.lang('Dinh_kem', 'en'),
                            hasURL: false
                        });
                    }
                })
            }
            if (attachmentsTemp.current.length > 0) {
                attachmentsTemp.current.forEach((item) => {
                    if (!props.attachments.find(rs => rs.URL === item.URL)) {
                        options.push({
                            codeID: SubContractID,
                            formID: "W06F0009",
                            action: 2,
                            oldValue: "",
                            newValue: item.FileName,
                            description84: Config.lang('Dinh_kem', 'vi'),
                            description01: Config.lang('Dinh_kem', 'en'),
                            hasURL: false
                        });
                    }
                });
            }
        }
        return options;
    }


    const onCreateSaveHistory = (SubContractID) => {
        const dataAttachmentHistory = onCreateAttachmentHistory(SubContractID);
        const dataMasterHistory = getOptions(dataGeneral.SubContractNo, SubContractID);
        return [...dataAttachmentHistory, ...dataMasterHistory];
    }

    const checkValidateMaster = (arrName) => {
        const resultValidate = arrName.map(item => {
            return {
                name: item,
                rules: ["isRequired"],
                value: dataGeneral[item]
            }
        });
        return resultValidate;
    }

    const setStateErrorText = (objValue) => {
        setErrors({ ...errors, ...objValue });
        return Object.keys(objValue).length !== 0;
    }

    return (
        <div>
            {openModalCustomer && <W91F0001 showW91F0001={openModalCustomer} ObjectTypeID={"CC"}
                onCloseModal={() => setOpenModalCustomer(false)}
                mode={1} onHide={(e) => {
                    handleChange("SupplierID", e);
                    setOpenModalCustomer(false);
                }}
            />}
            <Accordion expand boxShadow>
                <AccordionSummary >
                    <div className={classes.textInfo}>{Config.lang('Thong_tin_chung')}</div>
                </AccordionSummary>
                <AccordionDetails>
                    <Row >
                        <Col md={4}>
                            <Dropdown
                                dataSource={cbTypeAppendix}
                                displayExpr={"VoucherTypeName"}
                                valueExpr={"VoucherTypeID"}
                                label={Config.lang("Loai_phu_luc")}
                                value={_.get(dataGeneral, 'VoucherTypeID', 0)}
                                onChange={(e) => handleChange("VoucherTypeID", e)}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['VoucherTypeID']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={4}>
                            <TextInput
                                label={Config.lang('So_phu_luc')}
                                value={_.get(dataGeneral, 'SubContractNo', '')}
                                onChange={(e) => handleChange("SubContractNo", e)}
                                disabled={mode === 'view' || isReadOnlySubConTractNo.current}
                                error={errors?.SubContractNo}
                            // className={!Config.isEmpty(diff.current['SubContractNo']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={4}>
                            <Dropdown
                                dataSource={[{ id: '0', name: Config.lang('Chua_duyet') }, { id: '1', name: Config.lang('Da_duyet') }]}
                                displayExpr={"name"}
                                valueExpr={"id"}
                                label={Config.lang("Trang_thai")}
                                value={_.get(dataGeneral, 'IsApprove', 0)}
                                onChange={(e) => handleChange("IsApprove", e)}
                                disabled={true}
                                className={mode === 'add' && !Config.isEmpty(diff.current['IsApprove']) ? classes.diff : ''}
                            />
                        </Col>
                    </Row>
                    <Row >
                        <Col md={4}>
                            <TextInput
                                label={Config.lang('Loai_tien')}
                                value={_.get(dataGeneral, 'CurrencyID', '')}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['CurrencyID']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={4}>
                            <MoneyInput
                                label={Config.lang('Ty_gia')}
                                value={_.get(dataGeneral, 'ExchangeRate', '')}
                                thousandSeparator={','}
                                decimalDigit={_.get(decimalQuantity, 'ExchangeRateDecimals', 2)}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['ExchangeRate']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={4}>
                            <DatePicker
                                label={Config.lang('Ngay_lap')}
                                value={_.get(dataGeneral, 'SubContractDate', '')}
                                onChange={(e) => handleChange("SubContractDate", e)}
                                disabled={mode === 'view'}
                            />
                        </Col>
                    </Row>
                    <Row >
                        <Col md={4}>
                            <Dropdown
                                dataSource={cbEmployees.rows}
                                total={cbEmployees.total}
                                limit={filterCbEmployees.limit}
                                skip={filterCbEmployees.skip}
                                displayExpr={"{EmployeeID} - {EmployeeName}"}
                                valueExpr={"EmployeeID"}
                                label={Config.lang("Nguoi_lapU")}
                                value={_.get(dataGeneral, 'EmployeeID', '')}
                                onChange={(e) => handleChange("EmployeeID", e)}
                                onLoadMore={() => {
                                    setFilterCbEmployees({ ...filterCbEmployees, skip: filterCbEmployees.limit + filterCbEmployees.skip });
                                }}
                                disabled={mode === 'view'}
                                // className={!Config.isEmpty(diff.current['EmployeeID']) ? classes.diff : ''}
                                valueObjectDefault={{
                                    EmployeeID: _.get(formData, 'EmployeeID', ''),
                                    EmployeeName: _.get(formData, 'EmployeeName', '')
                                }}
                            />
                        </Col>
                        <Col md={4}>
                            <DatePicker
                                label={Config.lang('Ngay_bat_dau')}
                                value={_.get(dataGeneral, 'StartDate', new Date())}
                                onChange={(e) => handleChange("StartDate", e)}
                                disabled={mode === 'view'}
                                className={mode === 'add' && !Config.isEmpty(diff.current['StartDate']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={4}>
                            <DatePicker
                                label={Config.lang('Ngay_ket_thuc')}
                                value={_.get(dataGeneral, 'FinishDate', new Date())}
                                onChange={(e) => handleChange("FinishDate", e)}
                                disabled={mode === 'view'}
                                className={mode === 'add' && !Config.isEmpty(diff.current['FinishDate']) ? classes.diff : ''}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <Dropdown
                                dataSource={cbPaymentMenthod}
                                displayExpr={"{PaymentMethodID} - {PaymentMethodName}"}
                                valueExpr={"PaymentMethodID"}
                                label={Config.lang("Phuong_thuc_thanh_toan")}
                                value={_.get(dataGeneral, 'PaymentMethodID', '')}
                                onChange={(e) => handleChange("PaymentMethodID", e)}
                                disabled={mode === 'view'}
                                className={mode === 'add' && !Config.isEmpty(diff.current['PaymentMethodID']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={4}>
                            <Dropdown
                                dataSource={cbSubContractType}
                                displayExpr={"SubContractTypeName"}
                                valueExpr={"SubContractType"}
                                label={Config.lang("Loai_dieu_chinh")}
                                value={_.get(dataGeneral, 'SubContractType', '')}
                                onChange={(e) => handleChange("SubContractType", e)}
                                disabled={mode === 'view'}
                            />
                        </Col>
                    </Row>
                </AccordionDetails>
            </Accordion>
            <Accordion expand boxShadow>
                <AccordionSummary >
                    <div className={classes.textInfo}>{Config.lang('Nha_cung_cap')}</div>
                </AccordionSummary>
                <AccordionDetails>
                    <Row >
                        <Col md={3}>
                            <div onClick={e => mode !== 'view' && setOpenModalCustomer(true)}>
                                <Dropdown
                                    // dataSource={cbCustomer.rows}
                                    // total={cbCustomer.total}
                                    // limit={filterCbCustomer.limit}
                                    // skip={filterCbCustomer.skip}
                                    displayExpr={"ObjectNameU"}
                                    valueExpr={"ObjectID"}
                                    label={Config.lang("Nha_cung_cap")}
                                    value={_.get(dataGeneral, 'SupplierID', '')}
                                    // onChange={(e) => handleChange("SupplierID", e)}
                                    onLoadMore={() => {
                                        setFilterCbCustomer({ ...filterCbCustomer, skip: filterCbCustomer.limit + filterCbCustomer.skip });
                                    }}
                                    readOnly
                                    disabled={mode === 'view'}
                                    className={mode === 'add' && !Config.isEmpty(diff.current['SupplierID']) ? classes.diff : ''}
                                    valueObjectDefault={{
                                        ObjectID: _.get(dataGeneral, 'SupplierID', ''),
                                        ObjectNameU: _.get(dataGeneral, 'SupplierName', '')
                                    }}
                                />
                            </div>
                        </Col>
                        <Col md={9}>
                            <TextInput
                                label={Config.lang('Dia_chi')}
                                value={_.get(dataGeneral, 'ObjectAddressU', '')}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['ObjectAddressU']) ? classes.diff : ''}
                            />
                        </Col>
                    </Row>
                    <Row >
                        <Col md={3}>
                            <TextInput
                                label={Config.lang('Ma_so_thue')}
                                value={_.get(dataGeneral, 'VATNo', '')}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['VATNo']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={3}>
                            <TextInput
                                label={Config.lang('Tai_khoan')}
                                value={_.get(dataGeneral, 'BankAccountNo', '')}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['BankAccountNo']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={3}>
                            <TextInput
                                label={Config.lang('So_dien_thoai')}
                                value={_.get(dataGeneral, 'TelNo', '')}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['TelNo']) ? classes.diff : ''}
                            />
                        </Col>
                        <Col md={3}>
                            <TextInput
                                label={Config.lang('So_fax')}
                                value={_.get(dataGeneral, 'FaxNo', '')}
                                disabled
                                className={mode === 'add' && !Config.isEmpty(diff.current['FaxNo']) ? classes.diff : ''}
                            />
                        </Col>
                    </Row>
                    <Row >
                        {dataGeneral.IsGuarantee === 1 &&
                            <Col md={6}>
                                <Dropdown
                                    dataSource={cbConsignment.rows}
                                    total={cbConsignment.total}
                                    limit={filterCbConsignment.limit}
                                    skip={filterCbConsignment.skip}
                                    displayExpr={"{ObjectID} - {ObjectNameU}"}
                                    valueExpr={"ObjectID"}
                                    label={Config.lang("Don_vi_uy_thac")}
                                    value={_.get(dataGeneral, 'GObjectID', '')}
                                    onChange={(e) => handleChange("GObjectID", e)}
                                    onLoadMore={() => {
                                        setFilterCbConsignment({ ...filterCbConsignment, skip: filterCbConsignment.limit + filterCbConsignment.skip });
                                    }}
                                    disabled={mode === 'view'}
                                    className={mode === 'add' && !Config.isEmpty(diff.current['GObjectID']) ? classes.diff : ''}
                                />
                            </Col>
                        }
                        <Col md={dataGeneral.IsGuarantee ? 6 : 12}>
                            <TextInput
                                label={Config.lang('Ghi_chu')}
                                value={_.get(dataGeneral, 'Notes', '')}
                                onChange={(e) => handleChange("Notes", e)}
                                disabled={mode === 'view'}
                                className={mode === 'add' && !Config.isEmpty(diff.current['Notes']) ? classes.diff : ''}
                            />
                        </Col>
                    </Row>
                </AccordionDetails>
            </Accordion>
            <Accordion boxShadow>
                <AccordionSummary >
                    <div className={classes.textInfo}>{Config.lang('Thong_tin_khac')}</div>
                </AccordionSummary>
                <AccordionDetails>
                    <Row>
                        {arrSupplement.map((rs, i) => {
                            return (
                                <Col md={4} key={i}>
                                    {rs.DataType === 'datetime' ?
                                        <DatePicker
                                            label={rs.Caption}
                                            value={_.get(dataGeneral, rs.FieldName, '')}
                                            onChange={(e) => handleChange("arrSupplement", e.value, rs.FieldName)}
                                            disabled={mode === 'view'}
                                            className={mode === 'add' && !Config.isEmpty(diff.current[rs.FieldName]) ? classes.diff : ''}
                                            returnFormat={'YYYY-MM-DD'}
                                        />
                                        :
                                        rs.DataType.search("decimail") !== 0 ?
                                            <TextInput
                                                label={rs.Caption}
                                                value={_.get(dataGeneral, rs.FieldName, '')}
                                                onChange={(e) => handleChange("arrSupplement", e.target.value, rs.FieldName)}
                                                disabled={mode === 'view'}
                                                className={mode === 'add' && !Config.isEmpty(diff.current[rs.FieldName]) ? classes.diff : ''}
                                            /> :
                                            <NumberInput
                                                label={rs.Caption}
                                                value={_.get(dataGeneral, rs.FieldName, '')}
                                                onChange={(e) => handleChange("arrSupplement", Number(e.target.value), rs.FieldName)}
                                                disabled={mode === 'view'}
                                                className={mode === 'add' && !Config.isEmpty(diff.current[rs.FieldName]) ? classes.diff : ''}
                                            />}
                                </Col>
                            )
                        })}

                    </Row>
                </AccordionDetails>
            </Accordion>
            {mode !== 'view' &&
                <Attachment
                    className="mgt10"
                    ref={refAttachment}
                    data={attachment}
                    onChange={onChangeAttachments}
                    uploadErrorInfo={{
                        existingFile: Config.lang("File_da_duoc_dinh_kem"),
                        maxFile: Config.lang("File_vuot_qua_so_luong_cho_phep"),
                        maxSize: Config.lang("File_vuot_qua_dung_luong_cho_phep"),
                        fileType: Config.lang("File_khong_dung_dinh_dang"),
                    }}
                />
            }
        </div>
    );
}));

export default TabGeneral;